var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4586_1394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 40C33.9556 40 37.8224 38.827 41.1114 36.6294C44.4004 34.4318 46.9638 31.3082 48.4776 27.6537C49.9913 23.9992 50.3874 19.9778 49.6157 16.0982C48.844 12.2186 46.9392 8.65492 44.1421 5.85787C41.3451 3.06082 37.7814 1.15601 33.9018 0.384303C30.0222 -0.387401 26.0009 0.00866572 22.3463 1.52242C18.6918 3.03617 15.5682 5.59962 13.3706 8.8886C11.173 12.1776 10 16.0444 10 20C10.0053 25.3027 12.1141 30.3867 15.8637 34.1363C19.6133 37.8859 24.6973 39.9947 30 40ZM30 6.66668C32.6371 6.66668 35.2149 7.44866 37.4076 8.91375C39.6003 10.3788 41.3092 12.4612 42.3184 14.8976C43.3276 17.3339 43.5916 20.0148 43.0771 22.6012C42.5627 25.1876 41.2928 27.5634 39.4281 29.4281C37.5634 31.2928 35.1876 32.5627 32.6012 33.0771C30.0148 33.5916 27.3339 33.3276 24.8976 32.3184C22.4612 31.3092 20.3788 29.6003 18.9137 27.4076C17.4487 25.215 16.6667 22.6371 16.6667 20C16.6667 16.4638 18.0714 13.0724 20.5719 10.5719C23.0724 8.07143 26.4638 6.66668 30 6.66668Z",
    fill: "#4ABA6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0007 33.3333V23.3333H63.334V33.3333H53.334V39.9999H63.334V49.9999H70.0007V39.9999H80.0007V33.3333H70.0007Z",
    fill: "#4ABA6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4767 46.6667H16.5233C12.1427 46.672 7.943 48.4146 4.84542 51.5122C1.74784 54.6097 0.00529276 58.8094 0 63.1901L0 80.0001H6.66667V63.1901C6.66931 60.5767 7.70863 58.0712 9.55654 56.2233C11.4045 54.3754 13.91 53.3361 16.5233 53.3334H43.4767C46.09 53.3361 48.5955 54.3754 50.4435 56.2233C52.2914 58.0712 53.3307 60.5767 53.3333 63.1901V80.0001H60V63.1901C59.9947 58.8094 58.2522 54.6097 55.1546 51.5122C52.057 48.4146 47.8573 46.672 43.4767 46.6667Z",
    fill: "#4ABA6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4586_1394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditor);
export default __webpack_public_path__ + "static/media/auditor.551af0f0b5dbd21fe12f48bf70be1ddf.svg";
export { ForwardRef as ReactComponent };